export default __webpack_public_path__ + "static/media/logo-cartao-virtual-mastercard.d1fe8ba9.png";